export const NODE_WIDTH = 180;
export const NODE_HEIGHT = 30;
export const EDGE_COLOR = { normal: "#999", highlighted: "#0077ff" };
export const EDGE_THICKNESS = { normal: 1.5, highlighted: 3 };

export const statusToColor = (status) => {
  switch (status) {
    case 4:
      return "#B4E197";  // Green — clean
    case 3:
      return "#FFD699";  // Amber — suspicious
    case 2:
      return "#FFB3B3";  // Red — compromised
    case 1:
      return "#93C5FD";  // Blue — in progress
    case 0:
      return "#CCCCCC";  // Grey — not run
    case 10:
      return "#FCD34D";  // Yellow — failed
    default:
      return "#E0E0E0";  // Default grey
  }
};
